import { Root as e } from "./components/root/index.js";
import { Item as t } from "./components/item/index.js";
import { Link as n } from "./components/link/index.js";
// src/design/breadcrumbs/@/index.tsx
var r = {
	Root: e,
	Item: t,
	Link: n
};
export { r as Breadcrumb };

//# sourceMappingURL=index.js.map